export const toDateStr = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getFormatedTime = (date: Date) => {
  return (
    date.getHours().toString().padStart(2, "0") +
    ":" +
    date.getMinutes().toString().padStart(2, "0")
  );
};

export const displayDate = (createdAt: Date, withTime: boolean = true) => {
  const date = createdAt ? new Date(createdAt) : new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  if (!withTime) {
    return `${day}/${month}/${year}`;
  }

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const isBeforeDay = (a: Date, b: Date): boolean => {
  const dayA = new Date(a);
  const dayB = new Date(b);

  dayA.setHours(0, 0, 0, 0);
  dayB.setHours(0, 0, 0, 0);

  return dayA < dayB;
};

export const formatWithLeadingZero = (num: number): string => {
  if (num < 10) {
    return `0${num.toString()}`;
  }
  return num.toString();
};

export const getDayOfWeekEn = (day: number): string => {
  switch (day) {
    case 0:
      return "Sunday";
    case 1:
      return "Monday";
    case 2:
      return "Tuesday";
    case 3:
      return "Wednesday";
    case 4:
      return "Thursday";
    case 5:
      return "Friday";
    case 6:
      return "Saturday";
  }
  return "";
};

export const getDayOfWeekFr = (day: number): string => {
  switch (day) {
    case 0:
      return "Dimanche";
    case 1:
      return "Lundi";
    case 2:
      return "Mardi";
    case 3:
      return "Mercredi";
    case 4:
      return "Jeudi";
    case 5:
      return "Vendredi";
    case 6:
      return "Samedi";
  }
  return "";
};
